import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const CoingeckoIcon: React.FC<SvgProps> = ({ color, ...props }) => {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g id="[latest] coingecko_logo_with_text_biw_logo_with_dark_text copy 2 1" clipPath="url(#clip0_95_29635)">
        <g id="Coin_Gecko_AI">
          <g id="Group">
            <g id="XMLID_230_">
              <path
                id="Vector"
                d="M15.0601 7.30297C15.0344 7.22813 15.0053 7.15681 14.9712 7.08936C15.0162 7.16595 15.0453 7.23762 15.0601 7.30297Z"
                fill={color || '#999999'}
              />
            </g>
            <g id="XMLID_200_">
              <g id="XMLID_202_">
                <g id="Group_2">
                  <path
                    id="Vector_2"
                    d="M11.973 0.4132C5.57059 0.442361 0.403787 5.65554 0.432246 12.0587C0.461407 18.4612 5.67529 23.628 12.0777 23.5995C18.4802 23.5703 23.647 18.3572 23.6185 11.9547C23.5894 5.55154 18.3762 0.385093 11.973 0.4132ZM10.5055 11.4379C9.36014 11.4379 8.4319 10.5103 8.4319 9.36533C8.4319 8.22102 9.36014 7.29278 10.5055 7.29278C11.6498 7.29278 12.5781 8.22102 12.5781 9.36533C12.5781 10.5107 11.6498 11.4379 10.5055 11.4379ZM12.1582 13.6784L12.1691 13.665L12.1807 13.6517C12.7723 14.0332 13.4473 14.1678 14.1222 14.1878C14.7978 14.2054 15.4861 14.1544 16.1631 14.0181C16.8395 13.8776 17.5045 13.6699 18.1468 13.4047C18.5076 13.2561 18.8656 13.0937 19.2071 12.9026C19.2096 12.9009 19.2113 12.9002 19.2138 12.8984C19.4267 12.7705 19.6344 12.636 19.8378 12.4972C19.8817 12.4656 19.9249 12.4325 19.9674 12.3984L19.9723 12.4044L19.9899 12.4251C19.4689 12.8998 18.8481 13.2522 18.2163 13.5628C17.578 13.8635 16.9125 14.1095 16.2253 14.2876C15.5405 14.4647 14.8249 14.5985 14.1011 14.5328C13.3893 14.4696 12.6378 14.2205 12.1582 13.6784ZM17.4778 11.4379C17.4771 11.1895 17.6774 10.9882 17.9251 10.9868C18.1735 10.9861 18.3748 11.1853 18.3762 11.434C18.3769 11.6817 18.1766 11.8844 17.929 11.8851C17.6816 11.8858 17.4796 11.6856 17.4778 11.4379ZM13.9268 22.5574C13.4789 19.4203 16.219 16.3479 17.7638 14.7753C18.1145 14.4186 18.6562 13.9275 19.1607 13.4057C21.1662 11.531 21.565 9.29049 17.4613 8.17007C16.6835 7.94487 15.8775 7.62585 15.0603 7.30332C15.0346 7.22848 15.0055 7.15716 14.9714 7.0897C14.8776 6.92844 14.7138 6.74223 14.4651 6.53108C13.9314 6.06801 12.9294 6.08066 12.064 6.28514C11.1073 6.05993 10.1633 5.98018 9.25684 6.19695C5.28776 7.29067 4.64937 9.2269 4.49478 11.5591C4.28468 14.0796 4.16136 15.9579 3.20748 18.1045C2.01644 16.3869 1.31446 14.3034 1.30532 12.0545C1.27897 6.13406 6.05684 1.31333 11.9773 1.28663C17.8977 1.25993 22.7188 6.03779 22.7451 11.9582C22.7694 17.2462 18.9587 21.6583 13.9268 22.5574Z"
                    fill={color || '#999999'}
                  />
                </g>
              </g>
              <path
                id="XMLID_201_"
                d="M11.963 9.38447C11.963 10.1897 11.3099 10.8422 10.5053 10.8422C9.70002 10.8422 9.04688 10.1897 9.04688 9.38447C9.04688 8.5792 9.70002 7.92676 10.5053 7.92676C11.3095 7.92711 11.963 8.5792 11.963 9.38447Z"
                fill={color || '#999999'}
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_95_29635">
          <rect width="24" height="23.9171" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default CoingeckoIcon
